import Login from './login'
import SignUp from './signup'
import Guest from './guestForm'
import Cart from '../../shared/cart/cart'
import VueLoader from '../vue-loader'

document.addEventListener('turbolinks:load', () => {
  VueLoader.loadVueComponent(Login, document.getElementById('loginForm'))
  VueLoader.loadVueComponent(SignUp, document.getElementById('signupForm'))
  VueLoader.loadVueComponent(Guest, document.getElementById('guestForm'))
  VueLoader.loadVueComponent(Cart, document.getElementById('credentialsCart'))
})
